import { render, staticRenderFns } from "./Versicherer.vue?vue&type=template&id=845cefca&"
import script from "./Versicherer.vue?vue&type=script&lang=js&"
export * from "./Versicherer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports